package gr.tech.site.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initTermsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("terms.md", FrontMatterElement.Builder { addScalar("title", "Terms & Conditions"); }))
}

@Page("/terms")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun TermsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("terms-conditions") }) {
        org.jetbrains.compose.web.dom.Text("Terms & Conditions")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Effective Date:")
        }
        org.jetbrains.compose.web.dom.Text(" 01/01/2026")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("These Terms govern your use of the Green Rebates portal for the ETO Grow Light Fixture Program. By accessing or using the portal, you agree to these Terms.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("1-authorized-use") }) {
        org.jetbrains.compose.web.dom.Text("1. Authorized Use")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This portal is intended solely for authorized store representatives participating in the ETO Grow Light Fixture Program. Access is granted by Green Rebates and may be revoked at any time.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("2-account-responsibility") }) {
        org.jetbrains.compose.web.dom.Text("2. Account Responsibility")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account. Notify us immediately of any unauthorized access.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("3-accuracy-of-submissions") }) {
        org.jetbrains.compose.web.dom.Text("3. Accuracy of Submissions")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("By submitting an attestation form, you certify that the information provided is accurate and complete. Submission of false or misleading information may result in removal from the program and may have legal consequences.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("4-prohibited-conduct") }) {
        org.jetbrains.compose.web.dom.Text("4. Prohibited Conduct")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You agree not to use this portal for any unlawful purpose, attempt to access accounts or data you are not authorized to access, or take any action that disrupts or compromises portal functionality.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("5-limitation-of-liability") }) {
        org.jetbrains.compose.web.dom.Text("5. Limitation of Liability")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To the fullest extent permitted by law, Green Rebates LLC shall not be liable for any indirect, incidental, or consequential damages arising from your use of this portal.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("6-changes-and-termination") }) {
        org.jetbrains.compose.web.dom.Text("6. Changes and Termination")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We reserve the right to modify or discontinue the portal at any time. We may suspend or terminate access at our discretion if these Terms are violated.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("© 2026, Green Rebates. All Rights Reserved.")
    }
}
